import React from 'react';
import { Box, Heading, Paragraph } from 'components';
import type { ShipmentQuoteAppT } from 'apps/shipmentQuote/app';
import { formatDate, formatPrice } from 'utils/formatStrings';
import { DateWithTooltip } from 'apps/components/DateWithTooltip';

interface PriceSectionProps {
  quote: ShipmentQuoteAppT;
}

export const PriceSection = ({ quote }: PriceSectionProps) => {
  // TODO: currency may be added at the quote level from backend in the future
  // const { currency } = quote;
  const { currency } = quote.productQuotes.apps[0];

  const deliveryDate = quote.orders.apps[0]?.deliveryDate || quote.deliveryDate;

  return (
    <Box
      pl={8}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flex: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Heading level={3} size='large'>
          TOTAL PRICE:{' '}
        </Heading>
        <Heading level={3} size='large'>
          <span style={{ fontWeight: 'normal' }}>
            {formatPrice(quote.totalCost / 100, currency)}
          </span>
        </Heading>
      </Box>
      <Box mt={4}>
        <Heading level='5' size='small'>
          Created Date
        </Heading>
        <DateWithTooltip
          className='w-fit'
          tooltipProps={{
            place: 'right',
          }}
          date={quote.createdAt}
        />
      </Box>
      <Box mt={4}>
        <Heading level='5' size='small'>
          Estimated Delivery Date
        </Heading>
        <Paragraph>{formatDate(deliveryDate)}</Paragraph>
      </Box>
    </Box>
  );
};
